import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay, EffectFade } from 'swiper/modules';
import SLIDE11 from '../../assets/slides/slide1.jpg';
import SLIDE12 from '../../assets/slides/slide2.jpg';
import SLIDE13 from '../../assets/slides/slide3.jpg';
import SLIDE14 from '../../assets/slides/slide4.jpg';
import SLIDE15 from '../../assets/slides/slide5.jpg';
import SLIDE16 from '../../assets/slides/slide6.jpg';
import SLIDE17 from '../../assets/slides/slide7.jpg';
import ContactFloating from "../../components/contact-floating";
import CountUp from 'react-countup';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import './Home.styles.scss';

const Home = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Array de imágenes para el carousel
    const carouselImages = [
        {
            id: 1,
            image: SLIDE11,
            title: "Más de 60 años de experiencia",
            subtitle: "Servicio y venta automotor"
        },
        {
            id: 2,
            image: SLIDE12,
            title: "Vehículos 0KM y Usados",
            subtitle: "Encuentra tu auto ideal"
        },
        {
            id: 3,
            image: SLIDE13,
            title: "Taller Especializado",
            subtitle: "Mecánica general y especializada"
        },
        {
            id: 4,
            image: SLIDE14,
            title: "Motocicletas",
            subtitle: "Amplia variedad de modelos"
        },
        {
            id: 5,
            image: SLIDE15,
            title: "Calidad Garantizada",
            subtitle: "Repuestos originales y servicio profesional"
        },
        {
            id: 6,
            image: SLIDE16,
            title: "Equipamiento Moderno",
            subtitle: "Tecnología de última generación"
        },
        {
            id: 7,
            image: SLIDE17,
            title: "Tu Confianza, Nuestra Prioridad",
            subtitle: "Compromiso con cada cliente"
        }
    ];

    return (
        <div className="home-page">
            {/* Hero Section con Carousel de Portada */}
            <section className="hero-section">
                <div className="hero-fullscreen-carousel">
                    <Swiper
                        modules={[Pagination, Navigation, Autoplay, EffectFade]}
                        spaceBetween={0}
                        slidesPerView={1}
                        effect="fade"
                        fadeEffect={{ crossFade: true }}
                        navigation={{
                            nextEl: '.swiper-button-next-custom',
                            prevEl: '.swiper-button-prev-custom',
                        }}
                        pagination={{
                            clickable: true,
                            dynamicBullets: true,
                        }}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        loop={true}
                        speed={1500}
                        className="hero-swiper-fullscreen"
                    >
                        {carouselImages.map((item) => (
                            <SwiperSlide key={item.id}>
                                <div className="carousel-slide-fullscreen">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="carousel-image-fullscreen"
                                    />
                                    <div className="carousel-overlay-fullscreen">
                                        <div className="carousel-content-wrapper">
                                            <h3 className="carousel-slide-title">{item.title}</h3>
                                            {/* <p className="carousel-slide-subtitle">{item.subtitle}</p> */}
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    
                    {/* Contenido sobre el carousel */}
                    <div className="hero-overlay-content">
                        {/* <div className="hero-content-centered">
                            <h1 className="hero-title">
                                DINDORF
                                <span className="hero-subtitle">Servicio y Venta Automotor</span>
                            </h1>
                            <p className="hero-description">
                                Más de 60 años de experiencia en el sector automotor. 
                                Especialistas en mecánica, venta de vehículos usados, 0KM y motocicletas.
                            </p>
                            <div className="hero-stats">
                                <div className="stat-item">
                                    <CountUp
                                        start={0}
                                        end={60}
                                        duration={3}
                                        suffix="+"
                                        className="stat-number"
                                    />
                                    <span className="stat-label">Años de Experiencia</span>
                                </div>
                                <div className="stat-item">
                                    <CountUp
                                        start={0}
                                        end={2500}
                                        duration={3}
                                        suffix="+"
                                        className="stat-number"
                                    />
                                    <span className="stat-label">Vehículos Reparados</span>
                                </div>
                            </div>
                            <div className="hero-actions">
                                <Link to="/nosotros" className="btn-primary">
                                    Conocer Nuestra Historia
                                </Link>
                                <button
                                    onClick={() =>
                                        window.open(
                                            'https://wa.me/5492634588256?text=Hola,%20quisiera%20información%20sobre%20sus%20servicios',
                                            '_blank'
                                        )
                                    }
                                    className="btn-secondary"
                                >
                                    <i className="ri-whatsapp-line"></i>
                                    Contactar Ahora
                                </button>
                            </div>
                        </div> */}
                    </div>
                    
                    {/* Botones de navegación */}
                    <div className="swiper-button-prev-custom">
                        <i className="ri-arrow-left-s-line"></i>
                    </div>
                    <div className="swiper-button-next-custom">
                        <i className="ri-arrow-right-s-line"></i>
                    </div>
                </div>
            </section>
            <div className="flex flex-wrap max-w-2xl pl-2 pr-2 mx-auto mt-8 text-center text-gray-700 animate_animated animate__slideInUp animate__delay-2s md:container md:pl-0 md:pr-0">
                    <h1 className="text-3xl w-full flex-[100%] font-bold text-black md:text-4xl lg:text-5xl mb-6">
                        Nuestra Historia
                    </h1>
                    <div className="flex flex-col items-start justify-center lg:flex-row">
                        <div className="flex flex-col justify-between h-full px-4 leading-8 text-black lg:w-1/2">
                            <p className="mt-4 mb-4 text-black">
                                La historia de Dindorf comienza en 1966, pero nuestra pasión por la mecánica se remonta aún más atrás. 
                                En 1959, nuestro padre, Sebastian Carlos Dindorf, o mejor conocido como "kuki", se convirtió en uno de 
                                los mecánicos de motos más reconocidos del departamento, destacándose por su dedicación, experiencia y voluntad. 
                                Años más tarde, dimos un paso decisivo en nuestra historia al adquirir el terreno ubicado en calle Vicuña Prado, 
                                lugar que hoy alberga a Dindorf Servicio y Venta Automotor. Este hito marcó el inicio de una nueva etapa, 
                                que nos permitió crecer, consolidarse y proyectarse hacia el futuro.  
                                Desde entonces, hemos evolucionado constantemente, adaptándonos a los cambios y desafíos del sector automotor, 
                                pero sin perder jamás la esencia que nos distingue desde el primer día: el compromiso con nuestros clientes, 
                                la pasión por lo que hacemos y la búsqueda constante de la calidad y la confianza en cada servicio y venta.
                            </p>
                            {/* <a
                                href="https://wa.me/5492634588256?text=Hola,%20quisiera%20consultar%20sobre%20sus%20servicios"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="p-4 mb-4 text-xl text-gray-900 rounded-lg md:mr-6 md:text-3xl bg-slate-200 md:p-8"
                            >
                                Contáctanos
                            </a> */}
                        </div>
                    </div>
                </div>

            {/* Services Grid */}
            <section className="services-overview">
                <div className="container">
                    <h2 className="section-title">Nuestros Servicios</h2>
                    <div className="services-grid">
                        <Link to="/servicios" className="service-card">
                            <div className="service-icon">
                                <i className="ri-tools-line"></i>
                            </div>
                            <h3>Taller Mecánico</h3>
                            <p>Mecánica general, motores, frenos, cajas y más</p>
                            <span className="service-link">Ver servicios completos →</span>
                        </Link>

                        <Link to="/usados" className="service-card">
                            <div className="service-icon">
                                <i className="ri-car-line"></i>
                            </div>
                            <h3>Vehículos Usados</h3>
                            <p>Amplia selección de autos usados en excelente estado</p>
                            <span className="service-link">Ver catálogo →</span>
                        </Link>

                        <Link to="/0km" className="service-card">
                            <div className="service-icon">
                                <i className="ri-car-fill"></i>
                            </div>
                            <h3>Vehículos 0KM</h3>
                            <p>Autos nuevos con garantía oficial de fábrica</p>
                            <span className="service-link">Ver disponibles →</span>
                        </Link>

                        <Link to="/motos" className="service-card">
                            <div className="service-icon">
                                <i className="ri-motorbike-line"></i>
                            </div>
                            <h3>Motocicletas</h3>
                            <p>Desde urbanas hasta deportivas de alta cilindrada</p>
                            <span className="service-link">Ver motos →</span>
                        </Link>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="why-choose-us">
                <div className="container">
                    <h2 className="section-title">¿Por qué elegirnos?</h2>
                    <div className="features-grid">
                        <div className="feature-item">
                            <div className="feature-icon">
                                <i className="ri-time-line"></i>
                            </div>
                            <h3>Experiencia</h3>
                            <p>Más de 60 años brindando servicios de calidad en el sector automotor</p>
                        </div>
                        
                        <div className="feature-item">
                            <div className="feature-icon">
                                <i className="ri-user-star-line"></i>
                            </div>
                            <h3>Equipo Profesional</h3>
                            <p>Mecánicos especializados y capacitados para todo tipo de vehículos</p>
                        </div>
                        
                        <div className="feature-item">
                            <div className="feature-icon">
                                <i className="ri-shield-check-line"></i>
                            </div>
                            <h3>Garantía</h3>
                            <p>Todos nuestros trabajos cuentan con garantía y respaldo técnico</p>
                        </div>
                        
                        <div className="feature-item">
                            <div className="feature-icon">
                                <i className="ri-customer-service-line"></i>
                            </div>
                            <h3>Atención Personalizada</h3>
                            <p>Trato cercano y profesional, asesoramiento especializado</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Team Section */}
            <section className="team-preview">
                <div className="container">
                    <div className="team-content">
                        <div className="team-text">
                            <h2 className="section-title">Nuestro Equipo</h2>
                            <p>
                                Contamos con un equipo de profesionales altamente capacitados, 
                                dedicados a brindar un servicio integral, eficiente y de calidad.
                            </p>
                            <Link to="/equipo" className="btn-primary">
                                Conocer Nuestro Equipo
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Call to Action */}
            <section className="cta-section">
                <div className="container">
                    <div className="cta-content">
                        <h2>¿Necesitas nuestros servicios?</h2>
                        <p>Contáctanos y obtén la mejor atención para tu vehículo</p>
                        <div className="cta-buttons">
                            <button
                                onClick={() =>
                                    window.open(
                                        'https://wa.me/5492634588256?text=Hola,%20quisiera%20consultar%20sobre%20ventas',
                                        '_blank'
                                    )
                                }
                                className="cta-btn ventas"
                            >
                                <i className="ri-whatsapp-line"></i>
                                Consultar Ventas
                            </button>
                            <button
                                onClick={() =>
                                    window.open(
                                        'https://wa.me/2635000305?text=Hola,%20quisiera%20consultar%20sobre%20servicios',
                                        '_blank'
                                    )
                                }
                                className="cta-btn servicios"
                            >
                                <i className="ri-whatsapp-line"></i>
                                Consultar Servicios
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <ContactFloating />
        </div>
    );
};

export default Home;